const db = require("mime-db");

export const getExtsAndTypes = () => {
    let extensions = {}
    let types = {}
    // source preference (least -> most)
    const preference = ['nginx', 'apache', undefined, 'iana'];

    Object.keys(db).forEach(function forEachMimeType (type) {
        let mime = db[type]
        let exts = mime.extensions

        if (!exts || !exts.length) {
            return
        }

        // mime -> extensions
        extensions[type] = exts

        // extension -> mime
        for (let i = 0; i < exts.length; i++) {
            const extension = exts[i]

            if (types[extension]) {
                const from = preference.indexOf(db[types[extension]].source)
                const to = preference.indexOf(mime.source)

                if (types[extension] !== 'application/octet-stream' &&
                    (from > to || (from === to && types[extension].substr(0, 12) === 'application/'))) {
                    // skip the remapping
                    continue
                }
            }

            // set the extension -> mime
            types[extension] = type
        }
    })
    return {
        extensions,
        types
    }
}
